import React from 'react';
import { ROUTE_CHANGE_EVENT } from './_common';
import { createHashRoutingStrategy } from './hash';
import { createHistoryRoutingStrategy } from './history';
export { getRouteParams, getRouteParam, setRouteParam, makeRouteParamUrl, isCrossOrigin, carryOrigin } from './_common';
const routingStrategies = {
    'hash': createHashRoutingStrategy,
    'history': createHistoryRoutingStrategy,
};
export const createRoutingStrategy = (mode, basename) => routingStrategies[mode](basename);
export const onRouteChange = (f) => {
    window.addEventListener('popstate', f);
    window.addEventListener('hashchange', f);
    window.addEventListener(ROUTE_CHANGE_EVENT, f);
    return () => {
        window.removeEventListener('popstate', f);
        window.removeEventListener('hashchange', f);
        window.removeEventListener(ROUTE_CHANGE_EVENT, f);
    };
};
const RoutingStrategyContext = React.createContext({
    current: () => { throw 'not implemented'; },
    navigate: (_) => { throw 'not implemented'; },
    listen: (_) => { throw 'not implemented'; },
    pathToURL: (_) => { throw 'not implemented'; },
    parse: () => { throw 'not implemented'; },
    origin: () => { throw 'not implemented'; },
});
export const RoutingProvider = ({ strategy, children }) => {
    return React.createElement(RoutingStrategyContext.Provider, { 'value': strategy }, children);
};
export const useRoutingConfig = () => React.useContext(RoutingStrategyContext);
export const useRouting = () => {
    const strategy = React.useContext(RoutingStrategyContext);
    const [state, setState] = React.useState(() => strategy.current());
    React.useEffect(() => {
        setState(strategy.current());
    }, [strategy]);
    React.useEffect(() => strategy.listen(() => setState(strategy.current())), [strategy]);
    const navigate = React.useCallback((target, options) => strategy.navigate(target, options), [strategy]);
    return [state, navigate];
};
export default useRouting;
